<template>
  <div class="v2-profile-address">
    <v2-address-section
      :addresses="addressComposable"
      :countries="countryList"
    />
  </div>
</template>

<script>
import { computed, watch } from '@vue/composition-api'
import { useAddresses } from '@/composables/useAddresses'
import V2AddressSection from '@/views/v2/operations/V2AddressSection.vue'

export default {
  name: 'V2ProfileAddress',
  components: {
    V2AddressSection,
  },
  props: {
    addresses: {
      type: Array,
      default: () => [],
    },
    getUserProfile: {
      type: Function,
      default: null,
    },
    commonData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const addr = useAddresses()
    addr.initAddresses(props.addresses, addr.isNotEntityAdmin.value)

    const countryList = computed(() => props.commonData?.COUNTRIES || [])

    watch(
      () => props.addresses,
      newAddresses => {
        if (newAddresses) {
          addr.initAddresses(newAddresses, addr.isNotEntityAdmin.value)
        }
      },
    )

    return {
      addressComposable: addr,
      countryList,
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-profile-address {
  display: flex;
  flex-direction: column;
  gap: var(--v2-space-5);
}
</style>
